(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tiles-list"] && !Shopify.designMode) return;
  try {
    
/* Mobile layout logic */
document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('.tiles-grid');
  if (!grid) return;

  const mobileColumns = '{{ section.settings.mobile_columns }}';

  if (window.innerWidth < 750) {
    grid.style.gridTemplateColumns =
      mobileColumns === '2'
      ? 'repeat(2, 1fr)'
      : 'repeat(1, 1fr)';

    /* Center last tile if odd number in 2-column mobile layout */
    if (mobileColumns === '2') {
      const tiles = grid.children;
      if (tiles.length % 2 === 1) {
        tiles[tiles.length - 1].style.gridColumn = '1 / -1';
        tiles[tiles.length - 1].style.margin = '0 auto';
      }
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
